formattedError